<script lang="ts">
	import arrowRightIcon from "@assets/icons/arrow_right_alt.svg?raw";
	import iconIWhite from "@assets/icons/i_white.svg";
	import imgBanner1 from "@assets/images/hp-banner-1.png";
	import imgBanner2 from "@assets/images/hp-banner-2.png";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import { getChromosomeSearchPath } from "@core/schema/paths/getChromosomeSearchPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import TrustFactors from "./TrustFactors.svelte";
	import Formatted from "./common/Formatted.svelte";

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="grid-container full-width pb-10 lg:pb-24 pt-8 lg:pt-20 bg-gradient-to-b from-light/50 to-light">
	<div class="flex justify-center items-center gap-24">
		<div>
			<div class="flex flex-col gap-7 max-w-xl">
				<span class="uppercase text-xs font-semibold tracking-widest text-blue"
					><Formatted text="Molekulární biologie a cytogenetika" /></span
				>
				<h1>
					<Formatted text="clb[[Spolehlivá diagnostika pro]] vědu i praxi"></Formatted>
				</h1>
				<p class="md:text-md">
					<Formatted
						text="Dodáváme špičkové diagnostické reagencie a laboratorní vybave ní pro molekulární biologii, cytogenetiku a výzkum biomarkterů oxidačního stresu."
					/>
				</p>
			</div>
			<div class="flex flex-col-reverse lg:flex-row gap-3 lg:gap-5 mt-8">
				<Link href="#contact-form" class="flex items-center justify-center gap-1" variant={ButtonVariant.Primary}
					><span>Poptat produkty</span>
					<Icon icon={arrowRightIcon} class="w-3.5" /></Link
				>
				<Link
					class="flex items-center justify-center gap-1"
					variant={ButtonVariant.Outline}
					href={getChromosomeSearchPath(tenant, null)}
				>
					<span>Hledat dle chromozomu</span>
					<Icon icon={arrowRightIcon} class="w-3.5" />
				</Link>
			</div>
		</div>
		<div class="relative hidden lg:block">
			<Media
				class="z-20 relative"
				source={{ src: imgBanner1, type: "image/png" }}
				width={456}
				height={342}
				alt="Hp banner 1"
			></Media>
			<Media
				class="-ml-24 -mt-44 z-30 relative"
				source={{ src: imgBanner2, type: "image/png" }}
				width={192}
				height={272}
				alt="Hp banner 2"
			></Media>
			<Media
				class="absolute inset-0 -top-16 z-10"
				source={{ src: iconIWhite, type: "image/svg+xml" }}
				width={438}
				height={573}
				alt="Intimex icon I"
			></Media>
		</div>
	</div>
	<TrustFactors />
</section>
